App.StaffTableRowComponent = Em.Component.extend
  env:     Em.inject.service('environment')
  session: Em.inject.service('session')

  tagName: 'tr'
  staff: null
  currentUser: null

  classNameBindings: [ 'isMe', 'isDisabled' ]

  translatedRole: (->
    businessRoleName = @get('staff.business_role.name')
    if !Ember.isEmpty(businessRoleName)
      return businessRoleName

    role = @get('staff.role')
    @get('env').translate("staff.roles.#{role}")
  ).property('staff.role', 'staff.business_role')

  isMe: (->
    lhs = @get('staff.id')
    rhs = @get('session').get('currentUser._data.account.id')

    return false unless lhs and rhs

    lhs.toString() is rhs.toString()
  ).property('staff.id', 'session.currentUser.account.id', 'session.currentUser._data.account.id')

  isDisabled: (->
    @get('staff.disabled')
  ).property('staff.id', 'staff.disabled')

  handleClick: (->
    @sendAction 'onStaffClicked', @get('staff')
  ).on('click')
